import { createReducer, on } from '@ngrx/store';
import * as VetSettingsActions from './vet-settings.actions';
import { MediaCategory } from '../../../models/media/media-category.model';
import { ViewerTemplate } from '../../../models/media/vet-sale-template.model';

export interface VetSettingsState {
  mediaCategories: MediaCategory[];
  viewerTemplates: ViewerTemplate[];
  isSaved: boolean;
  // Add other state properties as needed...
}

export const initialState: VetSettingsState = {
  mediaCategories: [],
  viewerTemplates: [],
  isSaved: false
  // Initialize other state properties...
};

export const vetSettingsReducer = createReducer(
  initialState,
  on(VetSettingsActions.loadMediaCategoriesSuccess, (state, { mediaCategories }) => ({
    ...state,
    mediaCategories
  })),
  on(VetSettingsActions.loadViewerTemplatesSuccess, (state, { viewerTemplates }) => ({
    ...state,
    viewerTemplates
  })),
  // Add other reducer cases as needed...
  on(VetSettingsActions.saveViewerTemplateSuccess, (state, { response }) => ({
    ...state, isSaved: true,
    // Handle response if necessary
  })),
  on(VetSettingsActions.resetState, () => initialState)
);
